<div [formGroup]="form()">
  <!-- <div class="field brdr-bottom">
    <label class="field-label">Current Project Stage</label>
    <p-selectButton [options]="currentStageOptions" optionLabel="label" optionValue="value"
      formControlName="currentStage" styleClass="pill-select" />
  </div> -->
  <div class="field mobile-top">
    <label class="field-label">{{ intendedUseQuestionText() }}<span class="required">*</span></label>
    <div class="option-grid option-grid--two-col">
      <p-selectButton [options]="intendedUseOptions()" optionLabel="label" optionValue="value" [multiple]="true"
        formControlName="intendedUse" styleClass="option-card" />
    </div>
    @if (showOtherDescription) {
    <input pInputText id="intendedUseOtherDescription" class="w-full" formControlName="intendedUseOtherDescription"
      placeholder="Please describe your intended use..." />
    @if (errorFor('intendedUseOtherDescription', { required: 'Please describe your intended use.', maxlength: 'Keep this under 300 characters.' }); as msg) {
    <span class="error-text">{{ msg }}</span>
    }
    }
    @if (intendedUseTouched) {
    <span class="error-text">Select at least one intended use.</span>
    }
  </div>

  <div class="field mobile-top">
    <label class="field-label">{{ primaryInterestQuestionText() }}<span class="optional">Optional</span></label>
    <div class="option-grid option-grid--three-col">
      <p-selectButton [options]="primaryInterestOptions()" optionLabel="label" optionValue="value" [multiple]="true"
        formControlName="primaryInterest" styleClass="option-card" />
    </div>
  </div>

  <div class="field mobile-top">
    <label class="field-label">{{ aboutAduQuestionText() }}<span class="optional">Optional</span></label>
    <div class="option-grid option-grid--three-col">
      <p-selectButton [options]="aboutAduOptions()" optionLabel="label" optionValue="value" formControlName="aboutAdu"
        styleClass="pill-select" />
    </div>
  </div>
  <!-- <div class="field-row form-marb">
    <div class="field mobile-top mb-0">
      <label class="field-label">{{ needsFinancingQuestionText() }}<span class="optional">Optional</span></label>
      <div class="radio-group">
        @for (option of yesNoOptions; track option.value) {
        <div class="radio-option">
          <p-radioButton [inputId]="'needsFinancing-' + option.value" name="needsFinancing" [value]="option.value"
            formControlName="needsFinancing" />
          <label [for]="'needsFinancing-' + option.value">{{ option.label }}</label>
        </div>
        }
      </div>
    </div> -->

    <!-- @if (showMortgageQuestion) {
    <div class="field mobile-top mb-0">
      <label class="field-label">Do you have a current mortgage for your main property?<span
          class="required">*</span></label>
      <div class="radio-group">
        @for (option of yesNoOptions; track option.value) {
        <div class="radio-option">
          <p-radioButton [inputId]="'hasCurrentMortgage-' + option.value" name="hasCurrentMortgage"
            [value]="option.value" formControlName="hasCurrentMortgage" />
          <label [for]="'hasCurrentMortgage-' + option.value">{{ option.label }}</label>
        </div>
        }
      </div>
      @if (isInvalid('hasCurrentMortgage')) {
      <span class="error-text">Please let us know if you have a current mortgage.</span>
      }
    </div>
    } -->
  <!-- </div> -->

  <div class="field mobile-top">
    <label class="field-label" for="notes">{{ notesQuestionText() }}<span class="optional">Optional</span></label>
    <textarea pInputTextarea id="notes" class="w-full" rows="4" formControlName="notes"
      placeholder="Tell us anything else that may help our team understand your project..."></textarea>
    @if (errorFor('notes', { maxlength: 'Notes must be 500 characters or fewer.' }); as msg) {
    <span class="error-text">{{ msg }}</span>
    }
  </div>
</div>
